/**
 * Página de Carrinho de Previsão
 */

import React from 'react';
import { Layout, PainelPrevisao } from '@components';
import CarrinhoPrevisao from '../components/carrinho/CarrinhoPrevisao';
import { CarrinhoProvider } from '@contexts';

const CarrinhoPrevisaoPage: React.FC = () => {
  return (
    <Layout title="Carrinho de Previsão" showHeader showFooter footerType="default" showPainelPrevisao>
      <PainelPrevisao />
      <CarrinhoProvider tipo="previsao">
        <CarrinhoPrevisao />
      </CarrinhoProvider>
    </Layout>
  );
};

export default CarrinhoPrevisaoPage;
